/* ==========================================================================
   KERAYONG — product page behaviour (qty stepper + thumbnail sync)
   Extracted from the inline <script> in sections/main-product.liquid.
   Scoped to .k-product so it needs no section id; loaded globally and
   returns early on pages that have no product.
   ========================================================================== */
(function () {
  var root = document.querySelector('.k-product');
  if (!root || root.__kpInit) return;
  root.__kpInit = true;

  root.querySelectorAll('[data-kp-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = root.querySelector('.kp-qty__val');
      if (!input) return;
      var n = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-kp-qty'), 10);
      input.value = n < 1 ? 1 : n;
    });
  });

  var thumbs = root.querySelectorAll('[data-kp-thumb]');
  var slides = root.querySelectorAll('[data-kp-slide]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var s = root.querySelector('[data-kp-slide="' + t.getAttribute('data-kp-thumb') + '"]');
      if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
  if ('IntersectionObserver' in window && slides.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var i = en.target.getAttribute('data-kp-slide');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-kp-thumb') === i); });
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    slides.forEach(function (s) { io.observe(s); });
  }
})();
